import Util from "../../../utils/Util";
import Config from "./Config";

class FontLoad {
    constructor() {
    }

    load(names) {
        let that = this;
        return new Promise(async resolve => {
            if (names == null || names.length == 0) {
                resolve(false)
            }
            for (let index = 0; index < names.length; index++) {
                const name = names[index];
                var fileName = "";
                var fontName = "";
                for (let j = 0; j < Config.FontFamilys.length; j++) {
                    const cell = Config.FontFamilys[j];
                    if (cell.name == name) {
                        fileName = cell.file;
                        fontName = cell.class;
                        break;
                    }
                }
                if (fileName != null && fontName != null && 
                    fileName.length > 0 && fontName.length > 0) {
                    let loaded = await that.exe(fontName, fileName)
                    if (!loaded) {
                        console.log("load font error [" + fontName + "]");
                    }
                }
            }
            resolve(true)
        })
    }

    exe(fontName, fileName) {
        return new Promise(resolve => {
            try {
                let url = require("../../../assets/font/" + fileName)
                let type = Util.getUrlType(url)
                // console.log(fontName, url, type);
                let myFonts = new FontFace(fontName, 'url(' + url + ')');

                myFonts.load().then(function(loadFace){
                    document.fonts.add(loadFace);
                    resolve(true)
                });
            } catch (error) {
                console.log(error);
                resolve(false)
            }
        });
    }
}

export default new FontLoad()